import { useState } from 'react';
import { Typography, Box } from '@mui/material';
import FlightIcon from '@mui/icons-material/Flight';
import { CONFIG } from '~/config';
import { Carrier } from '~/types';

interface CarrierLogoProps {
  carrier: Carrier;
  flightNumber?: string;
  direction?: 'column' | 'column-reverse' | 'row' | 'row-reverse';
  hideText?: boolean;
  boxStyle?: Record<string, any>;
  imageStyle?: Record<string, any>;
}

const CarrierLogo = ({ carrier, flightNumber, direction, hideText, boxStyle, imageStyle }: CarrierLogoProps) => {
  const [imgError, setImgError] = useState(false);
  const imageUrl = `${CONFIG.env.apiBaseUrl}assets/carriers/${carrier.code}.png`;
  const flightNumberText = flightNumber ? `(${carrier.code}${flightNumber})` : '';

  const showImage = carrier.code && !imgError;

  return (
    <Box textAlign='center' display='inline-flex' alignItems='center' flexDirection={direction || 'column'} style={{ marginRight: 2, ...boxStyle }}>
      {showImage ? (
        <img
          src={imageUrl}
          alt={carrier.friendlyName}
          style={{ marginRight: direction === 'row' ? 10 : 0, ...imageStyle }}
          onError={() => setImgError(true)}
        />
      ) : (
        <FlightIcon style={{ fontSize: 32, marginRight: direction === 'row' ? 10 : 0, ...imageStyle }} />
      )}
      {
        !hideText &&
        <Typography variant='body2' textTransform='capitalize' maxWidth={direction !== 'row' ? 100 : '100%'}>
          <small>
            {`${carrier?.friendlyName ? carrier.friendlyName.toLowerCase() : ''}${flightNumberText}`}
          </small>
        </Typography>
      }
    </Box>
  );
};

export default CarrierLogo;
